// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"634acb2a","455":"585a5141","977":"842ad848"}[chunkId] + ".chunk.js";
};